module.exports = __webpack_public_path__ + "static/media/dollar.7c292ab8.svg";